<div id="managePopUp ">
  <div class="modal-header pd-xy-15">
    <h4 class="modal-title" id="modal-basic-title">{{!isDialPad ? authoringContentData?.common_authoring?.noLinesHeader : ''}}</h4>
    <button type="button" class="close def-selected" aria-label="Close" (click)="onClickClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="switch-popup-text">
    <p *ngIf="!isDialPad">{{authoringContentData?.common_authoring?.noLinesText}}</p>
    <p *ngIf="isDialPad && clickFlow === 2">{{authoringContentData?.common_authoring?.noPkgdProdText}}</p>
    <p *ngIf="isDialPad && clickFlow === 3">{{authoringContentData?.common_authoring?.noBSSText}}</p>
    <p *ngIf="isDialPad && (clickFlow === 5 || clickFlow === 6)">{{authoringContentData?.common_authoring?.noDialPadText}}</p>
  </div>

  <div class="modal-footer">      
    <button type="button" class="btn primary_btn" (click)="onClickClose()">{{authoringContentData?.changeNumberAuthoring?.BtnErrorTxt}}</button>
  </div>
</div>